module.exports = __webpack_public_path__ + "img/memorial-statue-cult.81b7e1c6.webp";